import DashboardIcon from "@mui/icons-material/Dashboard";
import LayersIcon from "@mui/icons-material/Layers";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import LabelIcon from "@mui/icons-material/Label";
import WorkIcon from "@mui/icons-material/Work";
import AddIcon from "@mui/icons-material/Add";
import GroupsIcon from "@mui/icons-material/Groups";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SummarizeIcon from "@mui/icons-material/Summarize";
import QueueIcon from "@mui/icons-material/Queue";
import ViewListIcon from "@mui/icons-material/ViewList";
import { Link } from "react-router-dom";
import DraftsIcon from '@mui/icons-material/Drafts';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FeedbackIcon from "@mui/icons-material/Feedback";
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';

export const roles = [
  {
    id: 1,
    value: "admin",
    label: "Admin",
    menus: [
      {
        id: 2,
        value: "dashboard",
        label: "Dashboard",
        path: "/admin/dashboard",
        icon: <DashboardIcon />,
        breadCrum: (
          <>
            Admin/<Link to="/admin/dashboard">Admin/Dashboard</Link>
          </>
        ),
      },
      {
        id: 3,
        value: "org_admins",
        label: "Org Admins",
        path: "/admin/org-admins",
        icon: <ViewListIcon />,
        breadCrum: (
          <>
            Admin/<Link to="/admin/org-admins">Org Admins</Link>
          </>
        ),
      },
      {
        id: 4,
        value: "credit-recharge",
        label: "Credit Recharge",
        path: "/admin/credit-recharge",
        icon: <ViewListIcon />,
        breadCrum: (
          <>
            Admin/<Link to="/admin/credit-recharge">Credit Recharge</Link>
          </>
        ),
      },
      {
        id: 4,
        value: "credit-charges",
        label: "Credit Charges",
        path: "/admin/credit-charges",
        icon: <ViewListIcon />,
        breadCrum: (
          <>
            Admin/<Link to="/admin/credit-charges">Credit Charges</Link>
          </>
        ),
      },
    ],
  },
  {
    id: 9,
    value: "hr",
    label: "HR",

    menus: [
      {
        id: 10,
        value: "dashboard",
        label: "Dashboard",
        path: "/hr/dashboard",
        icon: <DashboardIcon />,
        breadCrum: (
          <>
            HR/<Link to="/hr/dashboard">Dashboard</Link>
          </>
        ),
      },
      {
        id: 11,
        value: "jd list",
        label: "JD List",
        path: "/hr/jd-list",
        slug: 'jd-read',
        icon: <WorkIcon />,
        breadCrum: (
          <>
            HR/
            <Link to="/hr/jobs">Jobs</Link>
          </>
        ),
        // submenu: [
        //   {
        //     id: 12,
        //     value: "create jd",
        //     label: "Create JD",
        //     path: "/hr/jd-list/create-jd",
        //     icon: <AddIcon />,
        //     breadCrum: (
        //       <>
        //         HR/
        //         <Link to="/hr/jobs">Jobs</Link> /
        //         <Link to="/hr/jobs/add-job">Add Job</Link>
        //       </>
        //     ),
        //   },
        // ],
      },
      {
        id: 13,
        value: "batches",
        label: "Batches",
        path: "/hr/batches",
        slug: 'batch-read',
        icon: <LayersIcon />,
        breadCrum: (
          <>
            HR/
            <Link to="/hr/batches">Batches</Link>
          </>
        ),
        // submenu: [
        //   {
        //     id: 14,
        //     value: "add batch",
        //     label: "Add Batch",
        //     path: "/hr/batches/add-batch",
        //     icon: <AddIcon />,
        //     breadCrum: (
        //       <>
        //         HR/
        //         <Link to="/hr/batches">Batches</Link> /
        //         <Link to="/hr/batches/add-batch">Add Batch</Link>
        //       </>
        //     ),
        //   },
        // ],
      },
      {
        id: 15,
        value: "candidates",
        label: "Candidates",
        slug: 'candidate-read',
        path: "/hr/candidates",
        icon: <GroupsIcon />,
        breadCrum: (
          <>
            HR/
            <Link to="/hr/candidates">Candidates</Link>
          </>
        ),
      },

      {
        id: 16,
        value: "interviews",
        label: "Interviews",
        slug: 'interview-read',
        path: "/hr/interviews",
        icon: <AssessmentIcon />,
        breadCrum: (
          <>
            HR/
            <Link to="/hr/interviews">Interviews</Link>
          </>
        ),
      },
      // {
      //   id: 17,
      //   value: "employees",
      //   label: "Employees",
      //   slug: 'employee-read',
      //   path: "/hr/employees",
      //   icon: <PeopleAltIcon />,
      //   breadCrum: (
      //     <>
      //       HR/
      //       <Link to="/hr/employees">Employees</Link>
      //     </>
      //   ),
      // },
      {
        id: 13,
        value: "manage",
        label: "Manage",
        // path: "/hr/batches",
        //slug: 'batch-read',
        icon: <SettingsApplicationsIcon />,
        // breadCrum: (
        //   <>
        //     HR/
        //     <Link to="/hr/batches">Batches</Link>
        //   </>
        // ),
        submenu: [
          {
            id: 17,
            value: "skills",
            label: "Skills",
            slug: 'skill-read',
            path: "/hr/skills",
            icon: <AutoStoriesIcon />,
            breadCrum: (
              <>
                HR/
                <Link to="/hr/skills">Skills</Link>
              </>
            ),
          },
          {
            id: 17,
            value: "label",
            label: "Label",
            slug: 'label-read',
            path: "/hr/label",
            icon: <LabelIcon />,
            breadCrum: (
              <>
                HR/
                <Link to="/hr/label">Label</Link>
              </>
            ),
          },
          {
            id: 28,
            value: "Access Control",
            label: "Access Control",
            slug: 'access-read',
            path: "/hr/access-control",
            icon: <SummarizeIcon />,
            breadCrum: (
              <>
                Hr/
                <Link to="/hr/access-control">Access Control</Link>
              </>
            ),
          },
          {
            id: 28,
            value: "Question Set",
            label: "Question Set",
            slug: 'question-read',
            path: "/hr/question-set",
            icon: <QueueIcon />,
            breadCrum: (
              <>
                Hr/
                <Link to="/hr/question-set">Question Set</Link>
              </>
            ),
          },
          {
            id: 29,
            value: "Email Template",
            label: "Email Template",
            slug: 'email-template-read',
            path: "/hr/email-templates",
            icon: <DraftsIcon />,
            breadCrum: (
              <>
                Hr/
                <Link to="/hr/question-set">Email Template</Link>
              </>
            ),
          },
          {
            id: 30,
            value: "AI Avatar",
            label: "AI Avatar",
            slug: 'ai-avatar',
            path: "/hr/ai-avatar",
            icon: <SmartToyIcon />,
            breadCrum: (
              <>
                Hr/
                <Link to="/hr/ai-avatar">AI Avatar</Link>
              </>
            ),
          },
          {
            id: 31,
            value: "AI Agent",
            label: "AI Agent",
            slug: 'ai-agent',
            path: "/hr/agents",
            icon: <EngineeringIcon />,
            breadCrum: (
              <>
                Hr/
                <Link to="/hr/agents">AI Agent</Link>
              </>
            ),
          },
        ],
      },
      
    ],
  },
  {
    id: 18,
    value: "candidate",
    label: "Candidate",
    menus: [
      {
        id: 19,
        value: "dashboard",
        label: "Dashboard",
        path: "/candidate/dashboard",
        icon: <DashboardIcon />,
        breadCrum: (
          <>
            Candidate/<Link to="/candidate/dashboard">Dashboard</Link>
          </>
        ),
      },
    ],
  },
  {
    id: 99,
    value: "interviewer",
    label: "Interviewer",
    menus: [
      {
        id: 1,
        value: "dashboard",
        label: "Dashboard",
        path: "/panel/dashboard",
        icon: <DashboardIcon />,
        breadCrum: (
          <>
            Panel/<Link to="/panel/dashboard">Dashboard</Link>
          </>
        ),
      },
      {
        id: 2,
        value: "meetingCalendar",
        label: "Meeting Calendar",
        path: "/panel/meeting-calendar",
        icon: <CalendarTodayIcon />,
        breadCrum: (
          <>
            Panel/<Link to="/panel/meeting-calendar">Meeting Calendar</Link>
          </>
        ),
      },
      {
        id: 3,
        value: "interviewFeedback",
        label: "Interview Feedback",
        path: "/panel/interview-feedback",
        icon: <FeedbackIcon />,
        breadCrum: (
          <>
            Panel/<Link to="/panel/interview-feedback">Interview Feedback</Link>
          </>
        ),
      },
    ],
  },
  {
    id: 20,
    value: "employee",
    label: "Employee",
    menus: [
      {
        id: 21,
        value: "dashboard",
        label: "Dashboard",
        path: "/employee/dashboard",
        icon: <DashboardIcon />,
        breadCrum: (
          <>
            Employee/<Link to="/employee/dashboard">Dashboard</Link>
          </>
        ),
      },
      {
        id: 22,
        value: "skills",
        label: "My Skills",
        path: "/employee/my-skills",
        icon: <ViewListIcon />,
        breadCrum: (
          <>
            Employee/
            <Link to="/employee/my-skills">Skills</Link>
          </>
        ),
      },
      // {
      //   id: 6765,
      //   value: "assitant",
      //   label: "AI Assistant",
      //   path: "/employee/ai-assistant",
      //   icon: <AssessmentIcon />,
      //   breadCrum: (
      //     <>
      //       Employee/
      //       <Link to="/employee/ai-assistant">AI Assistant</Link>
      //     </>
      //   ),
      // },
      // {
      //   id: 23,
      //   value: "self-assessments",
      //   label: "Self Assessments",
      //   path: "/employee/self-assessments",
      //   icon: <AssessmentIcon />,
      //   breadCrum: (
      //     <>
      //       Employee/
      //       <Link to="/employee/self-assessments">Self Assessments</Link>
      //     </>
      //   ),
      // submenu: [
      //   {
      //     id: 25,
      //     value: "add sklills",
      //     label: "My Skills",
      //     path: "/employee/self-assessment/add-skills",
      //     icon: <AddIcon />,
      //     breadCrum: (
      //       <>
      //         Employee/
      //         <Link to="/employee/self-assessment">Self Assessment</Link> /
      //         <Link to="/employee/self-assessment/add-skills">My Skills</Link>
      //       </>
      //     ),
      //   },
      // ],
      // },
      // {
      //   id: 26,
      //   value: "ai-interview",
      //   label: "AI Interview",
      //   path: "/employee/ai-interview",
      //   icon: <AssessmentIcon />,
      //   breadCrum: (
      //     <>
      //       Employee/
      //       <Link to="/employee/ai-interview">AI Interview</Link>
      //     </>
      //   ),
      // },
      {
        id: 27,
        value: "skill gap analysis",
        label: "Skill Gap Analysis",
        path: "/employee/skill-gap-analysis",
        icon: <SummarizeIcon />,
        breadCrum: (
          <>
            Employee/
            <Link to="/employee/skill-gap-analysis">Skill Gap Analysis</Link>
          </>
        ),
      },
      // {
      //   id: 28,
      //   value: "suggested-courses",
      //   label: "Suggested Courses",
      //   path: "/employee/suggested-courses",
      //   icon: <AutoStoriesIcon />,
      //   breadCrum: (
      //     <>
      //       Employee/
      //       <Link to="/employee/suggested-courses">Suggested Courses</Link>
      //     </>
      //   ),
      // },
    ],
  },
];